module.exports = __webpack_public_path__ + "img/jimny-5-door-rojo.5a181b81.png";